import { apiDelete, apiGet, apiPost, invalidate } from "./client";
import type { ApiConfig } from "./client";

/** GET /config: every config entry. */
export function listConfigs<T = any[]>(config?: ApiConfig): Promise<T> {
  return apiGet<T>("/config", config);
}

/** GET /config/:key. */
export function getConfig<T = any>(key: string, config?: ApiConfig): Promise<T> {
  return apiGet<T>(`/config/${key}`, config);
}

/** POST /config (create or update an entry). */
export async function upsertConfig<T = any>(payload: unknown, config?: ApiConfig): Promise<T> {
  const result = await apiPost<T>("/config", payload, config);
  invalidate("/config");
  return result;
}

export async function removeConfig<T = any>(key: string, config?: ApiConfig): Promise<T> {
  const result = await apiDelete<T>(`/config/${encodeURIComponent(key)}`, config);
  invalidate("/config");
  return result;
}
